import { render, staticRenderFns } from "./ProjectDropdown.vue?vue&type=template&id=003f7ffb&"
import script from "./ProjectDropdown.vue?vue&type=script&lang=js&"
export * from "./ProjectDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports